import ContentLoader from "react-content-loader";

const SkeletonLoader = () => (
  <div className="space-y-6">
    <ContentLoader
      height={120}
      width={400}
      backgroundColor="#333"
      foregroundColor="#999"
    >
      <circle cx="50" cy="60" r="40" />
      <rect x="110" y="40" rx="4" ry="4" width="200" height="10" />
      <rect x="110" y="60" rx="4" ry="4" width="140" height="10" />
    </ContentLoader>

    <ContentLoader
      height={180}
      width={400}
      backgroundColor="#333"
      foregroundColor="#999"
    >
      <rect x="0" y="10" rx="4" ry="4" width="350" height="20" />
      <rect x="0" y="40" rx="4" ry="4" width="380" height="10" />
      <rect x="0" y="60" rx="4" ry="4" width="320" height="10" />
      <rect x="0" y="80" rx="4" ry="4" width="300" height="10" />
      <rect x="0" y="100" rx="4" ry="4" width="280" height="10" />
    </ContentLoader>

    <div className="grid grid-cols-3 gap-2">
      {[...Array(6)].map((_, i) => (
        <ContentLoader
          key={i}
          height={120}
          width={120}
          backgroundColor="#333"
          foregroundColor="#999"
        >
          <rect x="0" y="0" rx="4" ry="4" width="100%" height="100%" />
        </ContentLoader>
      ))}
    </div>
  </div>
);

export default SkeletonLoader;
